export default __webpack_public_path__ + "static/images/Mina_1_thumb.png";